import React from 'react'
import { FormattedMessage } from 'react-intl'
import { Breadcrumbs, BreadcrumbLink } from 'legacy/components/Breadcrumbs'

import RetailerRoute, { type RetailerRouteComponentProps } from 'legacy/components/RetailerRoute'

import DepartmentBreadcrumbLink from './DepartmentBreadcrumbLink'
import AisleBreadcrumbLink from './AisleBreadcrumbLink'
import withRetailerRouter from 'legacy/common/withRouter'

interface DepartmentsBreadcrumbsProps extends RetailerRouteComponentProps {}

const DepartmentsBreadcrumbs = ({ url }: DepartmentsBreadcrumbsProps) => (
  <Breadcrumbs>
    <BreadcrumbLink to={url('departments')}>
      <FormattedMessage id="catalog.departments.title" />
    </BreadcrumbLink>

    <RetailerRoute route="departments" component={DepartmentBreadcrumbLink} />
    <RetailerRoute route="aisles" component={AisleBreadcrumbLink} />
  </Breadcrumbs>
)

export default withRetailerRouter(DepartmentsBreadcrumbs)
